import request from '@/utils/request';
var serviceApi = process.env.VUE_APP_OKEY_SERVER_API;
export function translate(data) {
  return request({
    url: serviceApi + '/translateAi/translate',
    method: 'post',
    data: data
  });
}
export function getTranslate(data) {
  return request({
    url: serviceApi + '/translateAi/getTranslate',
    method: 'post',
    data: data
  });
}